import {Details} from "../constants/ServiceDetailConstants"
import authService from "../../../auth/AuthService";
import {apiActionsDPService} from "../../../middlewares/veritas-middleware/constants/ApiMiddlewareConstants";

const loadServiceDetail = ({serviceDetail, inputFields}) => ({
    type: Details.LOAD_SERVICE_DETAIL,
    payload: {serviceDetail, inputFields}
});

const clearDetailPage = () => ({
    type: Details.CLEAR_CURRENT_SERVICE_DETAIL,
});

const fetchOneDPService = ({serviceID, authToken}) => ({
    type: apiActionsDPService.GET,
    payload: {serviceID, authToken}
});

const fetchOneKYBService = ({serviceID, authToken}) => ({
    type: apiActionsDPService.GET_ONE_KYB,
    payload: {serviceID, authToken}
});

const toggleDeleteWarningService = () => ({
    type: Details.DELETE_SERVICE_WARNING,
});

const deleteDataService = (serviceID, dp_type, authToken) => ({
    type: apiActionsDPService.DELETE_KYC_SERVICE,
    payload: {serviceID, dp_type, authToken},
});

const deleteKYBDataService = (serviceID, authToken) => ({
    type: apiActionsDPService.DELETE_KYB_SERVICE,
    payload: {serviceID, authToken},
});

export function unmountServiceDetail() {
    return (dispatch) => {
        dispatch(clearDetailPage());
    }
}

export function fetchServiceDetails(serviceID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(fetchOneDPService({serviceID, authToken}))
    }
}

export function fetchKYBServiceDetails(serviceID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(fetchOneKYBService({serviceID, authToken}))
    }
}

/**
 * Action for setting successfully fetched service detail.
 */
export function fetchServiceDetailSuccess(serviceDetail, inputFields) {
    return (dispatch) => {
        dispatch(loadServiceDetail({serviceDetail, inputFields}))
    };
}

export function toggleDeleteServiceWarning() {
    return (dispatch) => {
        dispatch(toggleDeleteWarningService());
    }
}

export function deleteCurrentDataService(serviceID, dp_type) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dp_type === 'kyc'
            ? dispatch(deleteDataService(serviceID, dp_type, authToken))
            : dispatch(deleteKYBDataService(serviceID, authToken))
    }
}

const details = {
    Details,
}

export default details;